import { useDispatch, select } from '@wordpress/data';

export const useSalvarPalavraChave = () => {
  const { editPost, savePost } = useDispatch('core/editor');
  var urlBlog = window.location.href.split('/wp-admin')[0];

  const salvarPalavraChavePost = palavraChave => {
    const slug = removerAcentosOrtograficos(palavraChave.split(' ').join('-'));
    const permalinkTemplate = removerAcentosOrtograficos(urlBlog + '/%postname%/');

    editPost({
      permalink_template: permalinkTemplate,
      slug: slug,
      meta: { _opti_seo_focuskw: palavraChave },
    });

    savePost();
  };

  return { salvarPalavraChavePost };
};

function removerAcentosOrtograficos(text) {
  const maps = {
    á: 'a',
    à: 'a',
    â: 'a',
    ã: 'a',
    ä: 'a',
    é: 'e',
    è: 'e',
    ê: 'e',
    ë: 'e',
    í: 'i',
    ì: 'i',
    î: 'i',
    ï: 'i',
    ó: 'o',
    ò: 'o',
    ô: 'o',
    õ: 'o',
    ö: 'o',
    ú: 'u',
    ù: 'u',
    û: 'u',
    ü: 'u',
    ç: 'c',
    ñ: 'n',
  };

  return text.replace(/[áàâãäéèêëíìîïóòôõöúùûüçñ]/gi, match => maps[match] || match);
}

export const variavelEhValida = variavel =>
  ![null, undefined, '', ' ', NaN].includes(variavel) && !Number.isNaN(variavel);

export const objetoEhVazio = obj => Object.keys(obj).length === 0;

export const montarSlug = texto => {
  return texto === null || texto === undefined || texto === ''
    ? ''
    : texto
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replaceAll(' ', '-')
      .replace(/[^a-z0-9-]/g, '');
};

/**
* Função que combina arrays sem duplicar dados
* @param {Array} newArray - Novo array para adicionar
* @param {Function} setArray - Função setter do useState
*/
export const combinarArrays = (newArray, setArray) => {
  if (Array.isArray(newArray) && newArray?.length > 0) {
    setArray(prev => {
      const combined = [...prev, ...newArray];
      return [...new Set(combined)];
    });
  }
};

export const ehTipoLegibilidade = tipo => {
  return (
    tipo === 'legibilidade' ||
    tipo === 'legibilidadeVozPassiva' ||
    tipo === 'legibilidadeOrtografia' ||
    tipo === 'legibilidadeGramatica'
  );
}